<template>
  <section
    id="testimonial"
    class="testimonial"
    style="background-color: #fafbfc; padding: 20px"
  >
    <div class="container">
      <div class="row" style="padding-bottom:50px;padding-top:50px;">
        <div class="col">
          <div rounded style="margin-left: 15%; height: 380px; width: 380px">
            <b-carousel
              id="carousel-1"
              class=".animated slideOutRight"
              v-model="slide"
              :interval="4000"
              slideOutRight
              background="#ababab"
              img-width="380"
              img-height="380"
              style="text-shadow: 1px 1px 2px #333"
              ref="testimoniSlide"
            >
              <b-carousel-slide
                v-for="(testimonial1, index) in testimonials"
                :key="index"
                :img-src="testimonial1.image_jpg"
              ></b-carousel-slide>
            </b-carousel>
          </div>
        </div>
        <div class="col">
          <h3>
            <i class="fa fa-quote-left" style="color: #5e51a1;height:30px;widht:42px;"></i>
          </h3>
          <b-carousel
            id="carousel-2"
            class=".animated slideOutRight"
            v-model="slide"
            :interval="4000"
            no-touch
            slideOutRight
            img-width="1024"
            img-height="580"
            style="text-align: left !important; padding: 0px !important"
            ref="testimoniSlide"
          >
            <b-carousel-slide
              class="testimoni-carousel-caption"
              img-blank
              v-for="(testimonial1, index) in testimonials"
              :key="index"
              style="left:0px !important;"
            >
              <div
                class="testi-content"
                v-html="testimonial1.testimonial"
                style="
                  color: black;
                  text-align: left;
                  padding-bottom: 20px;
                  margin: 0px;
                  height: 120px;
                "
              ></div>
              <hr />
              <div
                class="testi-parner-name"
                v-html="testimonial1.partner_name"
                style="
                  font-size: 24px;
                  color: black;
                  text-align: left !important;
                  padding: 0px;
                  margin: 0px;
                  font-family: 'GothamMedium';
                  line-height: 32px;
                "
              ></div>
              <div
                class="testi-title"
                v-html="testimonial1.title"
                style="
                  color: #eba102;
                  text-align: left;
                  padding: 0px;
                  margin: 0px;
                  font-size: 16px;
                  font-family: 'GothamMedium';
                "
              ></div>
            </b-carousel-slide>
            <!-- Slides with image only -->
          </b-carousel>
          <div class="h2 mb-0" >
            <b-button
              style="background-color: white; border: none"
              @click="prev"
              ><img src="@/assets/images/arrow-left.svg" alt="" /></b-button>
            <b-button
              @click="next"
              style="background-color: white; border: none; margin-left: 10px"
              ><img src="@/assets/images/arrow-right.svg" alt="" /></b-button>
          </div>
        </div>
      </div>
    </div>
    <div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'Feature',
};
</script>
<script>
export default {
  data() {
    return {
      slide: 0,
      sliding: null,
      testimonials: [],
      loadingBanner: true,
    };
  },
  methods: {
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    prev() {
      this.$refs.testimoniSlide.prev();
    },
    next() {
      this.$refs.testimoniSlide.next();
    },
  },
  mounted() {
    this.$store.dispatch("fetchTestimonipage", {
      language: this.$store.getters.getLanguage,
      limit: 3,
      search_param: "",
      page: 1,
    });
  },
  created() {
    this.$store.watch(
      (state) => state.homepageTestimoni,
      (newValue) => {
        this.loadingBanner = true;
        this.testimonials = newValue;
        this.loadingBanner = false;
      }
    );
    this.$store.watch(
      (state) => state.language,
      (newValue) => {
        this.$store.dispatch("fetchTestimonipage", {
          language: newValue,
          limit: 3,
          earch_param: "",
          page: 1,
        });
      }
    );
  },
};
</script>
<style scoped>
.carousel,
.slide,
.carousel .carousel-inner,
.carousel .carousel-item.carousel .carousel-item,
.carousel .carousel-item img,
.carousel .carousel-control .carousel .carousel-slide{
  border-radius: 12px;
  overflow: hidden;
  top: 0 !important;
  bottom: auto;
  font-family: "GothamBook" !important;
  font-stretch: normal;
  font-style: normal;
  line-height: 27px;
  letter-spacing: 0 px;
  left: 2px !important;
}
</style>
